import type { TagSheetLineItem, TagSheetParseResult } from '../types';
import { getSubmittableMappedAds } from '../validation/validateLineItems';

export const getReviewLineItems = (parseResult: TagSheetParseResult): TagSheetLineItem[] => {
  const lineItemMap = new Map<string, TagSheetLineItem>();

  getSubmittableMappedAds(parseResult).forEach(({ lineItem, tagSheetAd }) => {
    const existing = lineItemMap.get(lineItem.id);

    if (existing) {
      existing.tagSheetAds.push(tagSheetAd);
    } else {
      lineItemMap.set(lineItem.id, {
        ...lineItem,
        tagSheetAds: [tagSheetAd],
      });
    }
  });

  return Array.from(lineItemMap.values());
};
